export enum SpecialType {
    NONE = 0,
    FEEDBACK = 1,
    AUDIO = 2,
    MISSION = 3,
    WAKEUP = 4
  }  